import React from 'react';
import classnames from 'classnames';
import EmailNotificationView from 'partial/EmailNotification/EmailNotificationView';

export const EmailUpdateAlertView = ({ ...props }) => {
  const { showSuccess, isAnimating } = props;
  const customClassName = classnames('emailNotification padT18 m-padT16', {
    'collapse padT0': isAnimating,
  });

  if (showSuccess === null) {
    return (
      <div className="t-bgWhite">
        <div className={customClassName}>
          <EmailNotificationView
            type="info"
            page="profile"
            description="Your email has been updated. Never miss an update about your score, credit health, or special offers."
            hasToggle={true}
            closable={true}
            {...props}
          />
        </div>
      </div>
    );
  } else if (showSuccess) {
    return (
      <div className="t-bgWhite">
        <div className={customClassName}>
          <EmailNotificationView
            type="success"
            title="Email notifications have been turned on"
            description="You can always change your email preferences in the notification settings."
            {...props}
          />
        </div>
      </div>
    );
  } else {
    return '';
  }
};
